module.exports = __webpack_public_path__ + "static/media/redeem-step-4.a1a5b312.svg";